import React, { useState, useEffect } from 'react'
import Image from '../Image'

import moment from 'moment'
import 'moment-timezone'

import Link from '../Link'
import {
  featuredEventContainer,
  featuredEventWrapper,
  featuredEventMetadata,
  featuredEventImage,
  featuredEventMarginClass,
  featuredEventImageClass,
  featuredEventDateTimeWrapper,
  featuredEventCountdownTimer,
  featuredEventCountdownTimerWrapper,
  featuredEventDiffUnit,
  featuredEventCTA,
  featuredEventContent,
  featuredEventContentBorderClass,
  featuredEventDateTime,
  featuredEventDate,
  featuredEventTime,
} from './index.module.css'

const Event = ({ event }) => {
  const eventDateTime = moment.utc(event?.dateTime)
  const [timeDiff, setTimeDiff] = useState(
    eventDateTime.diff(moment.utc(), 'minutes')
  ) // time diff measured with minutes
  const [timeZone, setTimeZone] = useState('')

  const showCountdownTimer =
    event?.dateTime && moment.utc().isBefore(event?.dateTime)

  useEffect(() => {
    setTimeZone(
      new Date(event?.dateTime)
        .toLocaleTimeString('en-us', {
          timeZoneName: 'short',
        })
        .split(' ')[2]
    )

    let timerId = null
    if (showCountdownTimer) {
      timerId = window.setInterval(() => {
        setTimeDiff(eventDateTime.diff(moment.utc(), 'minutes'))
      }, 1000 * 60) // count down every minute
    }

    return () => {
      if (timerId) {
        window.clearInterval(timerId)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={featuredEventWrapper}>
      <div
        className={[
          featuredEventMetadata,
          !event.image && showCountdownTimer ? featuredEventMarginClass : '',
          event.image ? featuredEventImageClass : '',
        ].join(' ')}
      >
        {event?.image && (
          <>
            {event?.ctaUrl ? (
              <Link className={featuredEventImage} to={event?.ctaUrl}>
                <Image
                  source={event?.image}
                  imgStyle={{
                    objectFit: 'cover',
                    objectPosition: '50% 50%',
                  }}
                />
              </Link>
            ) : (
              <div className={featuredEventImage}>
                <Image
                  source={event?.image}
                  imgStyle={{
                    objectFit: 'cover',
                    objectPosition: '50% 50%',
                  }}
                />
              </div>
            )}
          </>
        )}

        {showCountdownTimer && (
          <div className={featuredEventDateTimeWrapper}>
            <div className={featuredEventCountdownTimerWrapper}>
              {event?.dateTimeText && <h3>{event?.dateTimeText}</h3>}
              <div className={featuredEventCountdownTimer}>
                <div className={featuredEventDiffUnit}>
                  <h3>{Math.floor(timeDiff / (60 * 24))}</h3>
                  <small>Days</small>
                </div>
                <div className={featuredEventDiffUnit}>
                  <h3>{Math.floor((timeDiff % (60 * 24)) / 60)}</h3>
                  <small>Hours</small>
                </div>
                <div className={featuredEventDiffUnit}>
                  <h3>{timeDiff % 60}</h3>
                  <small>Minutes</small>
                </div>
              </div>
            </div>
            {event?.ctaText && event?.ctaUrl && (
              <Link className={featuredEventCTA} to={event?.ctaUrl}>
                {event?.ctaText}
              </Link>
            )}
          </div>
        )}
      </div>
      <div
        className={[
          featuredEventContent,
          showCountdownTimer ? featuredEventContentBorderClass : '',
        ].join(' ')}
      >
        {event?.ctaUrl && event?.title ? (
          <Link to={event?.ctaUrl}>
            <h3>{event?.title}</h3>
          </Link>
        ) : (
          <h3>{event?.title}</h3>
        )}
        {event?.dateTime && (
          <div className={featuredEventDateTime}>
            <small className={featuredEventDate}>
              {moment.utc(event?.dateTime).local().format('MM.DD.YYYY')}
            </small>

            <small className={featuredEventTime}>
              {moment.utc(event?.dateTime).local().format('h:mm A')} {timeZone}
            </small>
          </div>
        )}
        {event?.description && (
          <p className="paragraph">{event?.description?.description}</p>
        )}
        {!showCountdownTimer && event?.ctaText && event?.ctaUrl && (
          <Link className={featuredEventCTA} to={event?.ctaUrl}>
            {event?.ctaText}
          </Link>
        )}
      </div>
    </div>
  )
}

const FeaturedEvent = ({ events, backgroundColor }) => {
  events = events ? events : []
  return (
    <div
      className={featuredEventContainer}
      style={{ backgroundColor: backgroundColor || '#F2F2F2' }}
    >
      {events?.map((event) => (
        <Event key={event?.id} event={event} />
      ))}
    </div>
  )
}

export default FeaturedEvent
